module.exports = __webpack_public_path__ + "img/Qumulo.0f39c9d9.jpg";